module.exports = __webpack_public_path__ + "media/images/top/img_interview_ariyasu-772b86758fcf7d7924124c808cd3103b.jpg";